import * as THREE from 'three';
import { TransformControls } from './TransformControls';
import { scene, camera, cameraLocked, orbitControl, mirrorMode } from '../SceneManager';
import { quickSave } from '../helpers/SaveManager';

class Control {
	constructor(sceneManager, object, type, space = "local") {
		// Scene restoration can detach controls before the global export is ready.
		this.sceneManager = sceneManager;
		this.object = object
		this.transformControl = new TransformControls(camera, canvas);
		this.isAttached = false;

		if (object) {
			this.transformControl.attach(object);
		}

		this.transformControl.setMode(type);
		this.transformControl.setSpace(space);

		scene.add(this.transformControl);

		this.dragging = false;

		const startDrag = () => {
			orbitControl.enabled = false;
			this.dragging = true;
			sceneManager.stateManager.storeSceneState();
		}

		const endDrag = () => {
			orbitControl.enabled = !cameraLocked;
			this.dragging = false;
			sceneManager.syncIKTarget();
			quickSave()
		}

		this.transformControl.addEventListener('objectChange', () => this.updatePose());

		this.transformControl.addEventListener('mouseDown', event => {
			startDrag()
		});

		this.transformControl.addEventListener('mouseUp', event => {
			endDrag()
		});

		this.transformControl.addEventListener('touchstart', () => {
			startDrag()
		});
		this.transformControl.addEventListener('touchend', () => {
			endDrag()
		});
	}

	updatePose() {
		const sceneManager = this.sceneManager;
		if (this.object === sceneManager.ikTarget && sceneManager.ikChainBones) {
			const target = this.object.getWorldPosition(new THREE.Vector3())
			sceneManager.solveIK(target)
		} else if (mirrorMode && sceneManager.selectedManager.subject?.subjectType == "Character") {
			const character = sceneManager.selectedManager.subject;
			if (sceneManager.activeGizmo === "rotate") {
				character.mirrorRotation(this.object);
			} else if (sceneManager.activeGizmo === "scale") {
				character.mirrorScale(this.object);
			}
		}
		sceneManager.requestRender();
	}


	updateObject(newObject) {
		const sceneManager = this.sceneManager;
		if (newObject !== sceneManager.ikTarget) sceneManager.clearIKChain();
		this.transformControl.detach();
		this.transformControl.attach(newObject);

		newObject.renderOrder = -1;
		this.object = newObject;
		this.isAttached = true;
	}

	attach() {
		this.transformControl.attach();
		this.isAttached = true;
	}

	detach() {
		const sceneManager = this.sceneManager;
		sceneManager.clearIKChain();
		this.transformControl.detach();
		this.isAttached = false;
	}

	setMode(mode) {
		const sceneManager = this.sceneManager;
		if (mode == 'hidden') {
			this.detach();
			sceneManager.directionalLight.setVisibility(false);

		} else {
			this.transformControl.setMode(mode);
			sceneManager.directionalLight.setVisibility(true);

			if (mode == 'scale') {
				// this.transformControl.showX = false
				// this.transformControl.showY = false
				// this.transformControl.showZ = false
			}
		}
	}

	setVisibleAxis(x=true, y=true, z=true) {
		this.transformControl.showX = x;
		this.transformControl.showY = y;
		this.transformControl.showZ = z;
	}
}

export const gizmos = {
	TRANSLATE: 'translate',
	SCALE: 'scale',
	ROTATE: 'rotate',
	HIDDEN: 'hidden',
	NONE: 'none',
}

export default Control;